import { useQuery } from "react-query";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import { getBranches } from "../../../../../MyApi/sb/branches";
import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getEmployes } from "../../../../../MyApi/sb/employes";

import icons from "../../../../../Data/icons";

import classes from "./addCompanies.module.css";

const AddHolidays = ({
  setDate,
  date,
  setName,
  setDescription,
  sb_company_id,
  sb_branch_id,
  setSbBranchId,
  setSbEmployeId,
  setSbCompanyId,
  name,
  active,
  setActive,
}) => {
  const { t } = useTranslation();
  const page = 0;
  const companiesQuery = useQuery(["getcompanies", page], () =>
    getCompanies(page)
  );
  const branchesQuery = useQuery(
    ["getBranches", page, sb_company_id],
    () => getBranches(page, sb_company_id),
    {
      enabled: !!sb_company_id,
    }
  );
  const EmployesQuery = useQuery(["getemployes", page, sb_branch_id], () =>
    getEmployes(page, sb_branch_id)
  );

  const Abc = icons.abc;

  const companies = companiesQuery?.data?.data || [];
  const branshes = branchesQuery?.data?.data || [];
  const employes = EmployesQuery?.data?.data || [];

  const handleNameChange = (e) => {
    const { value } = e.target;
    setName(value);
  };
  const handleDesChange = (e) => {
    const { value } = e.target;

    setDescription(value);
  };
  const handelCompanyIdChange = (selectedOption) => {
    const companyId = selectedOption ? selectedOption.id : null;
    setSbCompanyId(companyId);
  };
  const handelBranchIdChange = (selectedOption) => {
    const branchId = selectedOption ? selectedOption.id : null;
    setSbBranchId(branchId);
  };
  const handelEmployeIdChange = (selectedOption) => {
    const employeId = selectedOption ? selectedOption.id : null;
    setSbEmployeId(employeId);
  };

  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };
  const handelDateChange = (e) => {
    const { value } = e.target;
    setDate(value);
  };

  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">{t("Name")} </label>
          <div className={classes.iconInput}>
            <Abc />
          </div>
          <input
            type="text"
            placeholder="ادخل الاسم "
            value={name}
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> {t("Description")} </label>
          <textarea
            name="description"
            onChange={handleDesChange}
            className={classes.inputCustom}></textarea>
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> {t("Companies")} </label>
          {!companiesQuery.data ? (
            <div>no data available</div>
          ) : (
            <Select
              type="text"
              placeholder="اختار الشركة"
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name}
              options={companies}
              isClearable={true}
              onChange={handelCompanyIdChange}
            />
          )}
        </div>
        <div className={classes.formCol}>
          <label htmlFor="branches"> {t("Branches")} </label>
          {!branchesQuery.data ? (
            <div>يجب اختيار شركة</div>
          ) : (
            <Select
              type="text"
              placeholder="اختار الفرع"
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name}
              isClearable={true}
              options={branshes}
              onChange={handelBranchIdChange}
            />
          )}
        </div>
        <div className={classes.formCol}>
          <label htmlFor="employes"> {t("Employes")} </label>
          {!EmployesQuery.data ? (
            <div>no data available</div>
          ) : (
            <Select
              type="text"
              placeholder="اختار الموظفين"
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name_ar}
              isClearable={true}
              options={employes}
              onChange={handelEmployeIdChange}
            />
          )}
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">{t("Date")}</label>
          <input
            type="date"
            onChange={handelDateChange}
            className={classes.inputCustom}
          />
        </div>

        <div className={classes.formCol}>
          <label
            htmlFor="active"
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {active === 1 ? " نشط" : "غير نشط"}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleActiveChange}
              checked={active}
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default AddHolidays;
